export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <span className="font-heading text-xl font-extrabold text-primary-400">白云视频</span>
            <p className="text-white/50 text-sm mt-3 leading-relaxed">
              高清影视资源聚合平台，汇聚最新电影、热播电视剧、综艺节目与独家剧集，在线观看不缓冲，每日持续更新。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-white mb-4">快速导航</h4>
            <div className="space-y-2">
              {[
                { label: '首页', href: '#hero' },
                { label: '专题合集', href: '#index' },
                { label: '焦点专题', href: '#carousel' },
                { label: '热门榜单', href: '#ranking' },
                { label: '精彩推荐', href: '#media' },
                { label: '联系我们', href: '#contact' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="block text-white/50 text-sm hover:text-primary-400 transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-white mb-4">内容分类</h4>
            <div className="space-y-2">
              {['最新电影', '热播电视剧', '综艺节目', '动漫番剧', '纪录片', '悬疑推理'].map((cat) => (
                <a
                  key={cat}
                  href="#index"
                  className="block text-white/50 text-sm hover:text-primary-400 transition-colors cursor-pointer"
                >
                  {cat}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-white mb-4">合作伙伴</h4>
            <p className="text-white/40 text-sm leading-relaxed">
              更多合作伙伴信息即将上线，敬请期待。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/10 text-white/60 hover:bg-primary-500 hover:text-white transition-all cursor-pointer">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/10 text-white/60 hover:bg-primary-500 hover:text-white transition-all cursor-pointer">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/10 text-white/60 hover:bg-primary-500 hover:text-white transition-all cursor-pointer">
                <i className="ri-mail-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/30 text-xs">
            &copy; 2026 白云视频 版权所有 | 高清影视资源聚合平台
          </p>
          <p className="text-white/30 text-xs">
            97视频 · 丝瓜视频 · 蓝莓视频 · 91在线视频 同类高清影视
          </p>
        </div>
      </div>
    </footer>
  );
}